module.exports = __webpack_public_path__ + "static/default-e37922c107d6ea5b9b3e52d3d7e11445.jpeg";